// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__1V1s-","scrollingBanner":"styles_scrollingBanner__3XEBL","my-animation":"styles_my-animation__iJzgO","modalBanner":"styles_modalBanner__2427s"};